<template>
  <div id="bv-timer" v-if="isShow">
    <!-- 返回按钮 -->
    <div class="left-btn" v-show="count == time && !isReceive && !check && isReturn" @click="isShowReceive = true"></div>
    <!-- 圆形加载进度条 -->
    <div ref="circular" class="circular" :class="!check && !isReceive ? 'bgc-start' : 'bgc-end'" @click="toReceive()">
      <template v-if="!check && !isReceive">
        <div class="circular-loading" :class="time > count ? 'bgc-center' : 'bgc-center2'">
          <div class="wapper">
            <div class="rect right">
              <div class="circle circle_right" ref="rightStyle" :style="rightStyle"></div>
            </div>
            <div class="rect left">
              <div class="circle circle_left" ref="leftStyle" :style="leftStyle"></div>
            </div>
          </div>
        </div>
      </template>
      <div v-else style="margin-top: 0.25rem;">
        <p>{{credit}}</p>
        <p style="line-height: 1.2rem;">学分</p>
      </div>
    </div>
    <!-- 时间按钮 -->
    <div ref="credit" class="credit-btn" style="text-align: center;" v-if="!check && !isReceive" @click="toReceive()">
      <span ref="num">{{time}}S</span>
    </div>
    <div ref="credit2" class="credit-btn2" v-else>
      <span>已领取</span>
    </div>
    <!-- 弹出框 -->
    <div class="mall-mask" v-show="isShowReceive || isShowLogin">
    <!-- <div class="mall-mask"> -->
      <div class="mall-popup">
        <p v-if="isLogin || isShowReceive">您还有学分未领取哦</p>
        <p v-else>您暂未登录，不可领取学分</p>
        <img :src="`${staticPath}/timer/pops-up.png`" alt="">
        <div class="mall-btns">
          <div v-for="(item, index) in btnTxt" :key="index" class="mall-btn" v-show="isLogin || isShowReceive ? index >= 2 : index < 2" @click="toActivity(index)">{{ item }}</div>
        </div>
      </div>
    </div>
    <!-- 提示框 -->
    <div class="bc-ps-a bc-t-white bc-f-16rp bc-pd-tb-13rp bc-pd-lr-35rp bc-bd-radius-6 bc-t-c" style="top:50%;left: 50%;transform: translate(-50%, -50%);background-color:rgba(0,0,0,0.6); z-index: 999;" v-if="isTips && flag && !isReceive">
      <div class="bc-pd-tb-2rp">领取成功！</div>
      <div class="bc-pd-tb-2rp">获得&nbsp;{{credit}}&nbsp;学分</div>
    </div>
  </div>
</template>

<script>
let _time;
let timer; // 计时器
let roll = document.styleSheets[0];
let isProd = true; // 禁用console
if (isProd) {
	var console = {};
	console.log = function () {};
}

import { unLogin } from '$assets/js/login';
import programUrl from "@config/program-url";

export default {
  name: "w-timer",
  data() {
    return {
      isLogin: '', // 是否已登录
      time: 0, // 看多少分钟可以领取
      credit: 0, // 可领取的学分数
      check: false, // 当前页面是否学习过
      readNum: 0,// 已经学的次数
      integralNum: 0,// 可以学习的次数
      rightStyle: "", // 右边半圆执行的时间
      leftStyle: "", // 左边半圆执行的时间
      count: 0, // 当前页面的浏览时间
      flag: true, // 是否第一次显示提示框
      isTips: false, // 是否显示提示框
      isShow: false,
      isShowLogin: false, // 是否显示登录的弹出框
      isShowReceive: false, // 是否显示领取的弹出框
      isReceive: false, // 是否已领取学分
      userInfo: {}, // 用户领取信息
      isReturn: true, // 二级页面是否弹框
      isPhysicsReturn: false, // 是否是物理返回
      btnTxt: ["继续阅读", "登录领学分", "直接离开", "领取学分"]
    };
  },
  computed: {
    staticPath() {
      return `${this.config.path.static}/img/disease`;
    }
  },
  watch: {
    count(newVal, oldVal) {
      let ele = this.$refs.circular;
      let classVal = ele.getAttribute('class');
      if(newVal >= this.time && classVal) {
        classVal = classVal.replace("bgc-start","bgc-loading");
        setTimeout(() => {
          if(this.$refs.num) this.$refs.num.innerText = this.credit + '学分';
        }, 500);
      } else {
        classVal = classVal.replace("bgc-loading","bgc-start");
      }
      // 动态添加背景图
      ele.setAttribute("class",classVal);
    }
  },
  methods: {
    toActivity(index) {
      switch (index) {
        // 继续阅读
        case 0:
          this.isShowLogin = false;
          this.isShowReceive = false;
          break;
        // 登录领学分
        case 1:
          this.isShowLogin = false;
          // 跳转到登录之前存储可以领取学分的信息
          this.toLogin();
          break;
        // 直接离开
        case 2:
          this.isShowReceive = false;
          let ele = document.getElementsByClassName('bv-header-btn')[0];
          ele.click();
          break;
        // 领取学分
        case 3:
          this.isShowReceive = false;
          this.toReceive();
          break;
        default:
          break;
      }
    },
    // 监听页面的后退/返回(移动端/PC端)
    // 获取用户领取信息
    async getData() {
      if(this.$route.path !== "/disease/diseaseKown") {
        const { data } = await this.$axios.post("/api/Index/book_read", {
          read_column: this.$route.path, // 页面的路径
          article_id: this.$route.query.id || this.$route.query.cont // 当前页面的id
        });
        if(data.code == 200) {
          this.userInfo = data.data;
          if(this.userInfo.integral_time && this.userInfo.integral_time !== 0) {
            this.time = this.userInfo.integral_time;
          } else {
            return;
          }
          if(this.userInfo.integral && this.userInfo.integral !== 0) {
            this.credit = this.userInfo.integral;
          } else {
            return;
          }
          this.readNum = this.userInfo.book_read_num;
          this.integralNum = this.userInfo.integral_num;
          this.check = this.userInfo.check;
          this.memberId = this.userInfo.member_id;
          if(this.integralNum > this.readNum && this.$route.path !== "/disease/diseaseKown") {
            this.isShow = true;
          } else {
            return;
          }
          // 判断是否登录
          if(this.memberId) {
            this.isLogin = true;
          } else {
            this.isLogin = false;
          }
          setTimeout(() => {
            this.time && this.loadStatus();
          }, 1000);
        }
      }
    },

    // 阅读送学分存记录
    async submitData() {
      const { data } = await this.$axios.post("/api/Index/book_log", {
        read_column: this.$route.path, // 页面的路径
        article_id: this.$route.query.id || this.$route.query.cont, // 当前页面的id
        status: '1', // 领学分的标识
      });
      // 判断是否绑定手机号
      if(data.code == 200) {
        // 判断是否领取成功
        if(data.data.check) {
          this.isTips = true;
          // 关闭提示框
          setTimeout(() => {
            this.isReceive = true;
            this.isTips = false;
            this.flag = false;
          }, 1000);
        } else {
          this.$toast(data.data.msg);
          return false;
        }
      } else if(data.code == 10002) {
        this.$toast('未绑定手机');
        return false;
      } else {
        return false;
      }
    },

    // 登录
    toLogin() {
      /*app ——> 去登录  微信绑定手机号*/
      if (!this.isLogin) {
        unLogin();
        return;
      }
    },

    // 领取学分
    toReceive() {
      // 判断是否到领取学分的时间&&是否已领取
      if(this.count >= this.time && !this.isReceive) {
        // 判断是否已经登录
        if(this.isLogin) {
          // 弹框提示领取学分成功
          this.toTips();
        } else {
          this.isShowLogin = true;
        }
      } else {
        //  this.$toast('学分领取时间');
        return false;
      }
    },

    // 提示&提交
    toTips() {
      // 只提示一次领取成功
      if(this.flag && !this.check) {
        this.submitData();
      }
      // // 关闭提示框
      // setTimeout(() => {
      //   this.isReceive = true;
      //   this.isTips = false;
      //   this.flag = false;
      // }, 1000);
    },

    // 开始动画
    toAnimation() {
      // 设置动画时间
      if(this.time) {
        let animationTime = Math.floor(this.time / 2);
        this.rightStyle = { animation: `roll ${animationTime}s linear 0s 1 forwards` };
        this.leftStyle = { animation: `roll ${animationTime}s linear ${animationTime}s 1 forwards` };
      }
      // 写入动画剧本
      roll.insertRule(`@keyframes roll{0%{transform: rotate(0deg);} 100%{transform: rotate(180deg);}}`, 1);
    },

    // 开始计时
    startClock() {
      if (this.count < this.time) {
        timer = setTimeout(() => {
          this.count++; // 递增
          // console.log('当前时间：',this.count);
          if(this.$refs.num) {
            this.$refs.num.innerText = this.time - this.count + 'S';
          }
          this.startClock(this.count); // 递归
        }, 1000);
      } else {
        timer && clearTimeout(timer); // 清除定时器
      }
    },
    
    // 开始进度条动画`
    loadStatus() {
      this.toAnimation();
      this.startClock();
    },

    // 暂停&&继续动画
    isRoll(action) {
      if(!this.check && !this.isReceive) {
        this.$refs.rightStyle.style.WebkitAnimationPlayState = action;
        this.$refs.leftStyle.style.WebkitAnimationPlayState = action;
        this.$refs.credit.style.opacity = action == "paused" ? 0 : 1;
        this.$refs.credit.style.zIndex = action == "paused" ? -999 : 999;
        if(action == "paused") {
          _time = this.count;
          this.isReturn = false;
          timer && clearTimeout(timer);
        } else {
          if(_time) {
            // 将暂停时间作为初始时间
            this.count = _time;
            this.isReturn = true;
            this.loadStatus();
          }
        }
      } else {
        this.$refs.credit2.style.opacity = action == "paused" ? 0 : 1;
      }
      this.$refs.circular.style.opacity = action == "paused" ? 0 : 1;
      this.$refs.circular.style.zIndex = action == "paused" ? -999 : 999;
    }
  },
  created() {
    this.getData();
  },
  beforeDestroy() {
    // 清除上一次动画
    // roll.deleteRule(0);
    timer && clearTimeout(timer);
  }
};
</script>

<style scoped lang="scss">
$length: 4rem; // 圆形大小
$color: #ffeb00; // 进度条颜色

#bv-timer {
  overflow:hidden;
  .left-btn {
    width: 3rem;
    height: 3rem;
    position: absolute;
    left: 0;
    top: 0;
    z-index: 999;
  }

  // 圆形加载条
  .circular {
    width: $length;
    height: $length;
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translate(0, -50%);
    z-index: 999;
    text-align: center;
    .circular-loading {
      width: $length;
      height: $length;

      // 加载动画
      .wapper {
        box-sizing: border-box;

        .rect {
          position: absolute;
          width: $length / 2;
          height: $length;
          overflow: hidden;

          .circle {
            position: absolute;
            width: $length;
            height: $length;
            border-radius: 50%;
            -moz-box-sizing: border-box; /* Firefox */
            -webkit-box-sizing: border-box; /* Safari */
            box-sizing: border-box;
            border: 0.47rem solid $color;
          }
        }
        .right {
          left: 50%;
        }
      }

      .circle_right {
        left: -100%;
        clip: rect(0px $length / 2 $length 0px);
      }

      .circle_left {
        clip: rect(0px $length $length $length / 2);
      }
      .paused {
        animation-play-state: paused;
      }
    }
    p {
      margin: 0;
      padding: 0;
      color: #ffac00;
      font-weight: 1000;
    }
  }

  // 学分按钮
  .credit-btn {
    position: absolute;
    right: 1rem;
    width: 4.2rem;
    top: 53%;
    height: 1.2rem;
    background: #FFAC00;
    border-radius: 1rem;
    z-index: 1000;
    line-height: 1.2rem;
    span {
      color: #fff;
    }
  }

  .credit-btn2 {
    position: absolute;
    right: 1rem;
    width: 4.2rem;
    top: 53%;
    height: 1.2rem;
    background: #666666;
    border-radius: 1rem;
    z-index: 1000;
    line-height: 1.2rem;
    text-align: center;
    span {
      color: #fff;
    }
  }

  // 背景图
  .bgc-start {
    background: url($base-url + "/img/disease/timer/timer-bgc1.png") no-repeat;
    background-size: 100% 100%;
  }
  .bgc-loading {
    background: url($base-url + "/img/disease/timer/timer-bgc2.png") no-repeat;
    background-size: 100% 100%;
  }
  .bgc-end {
    // background: url($base-url + "/img/disease/timer/timer-bgc3.png") no-repeat;
    // background-size: 100% 100%;
    box-sizing: border-box;
    background-color: #ffffff;
    border: 0.47rem solid #f8d68f;
    border-radius: 50%;
  }
  .bgc-center {
    background: url($base-url + "/img/disease/timer/timer-center.gif") no-repeat;
    background-size: 70% 70%;
    background-position: 50% 50%;
  }
  .bgc-center2 {
    background: url($base-url + "/img/disease/timer/timer-center2.gif") no-repeat;
    background-size: 70% 70%;
    background-position: 50% 50%;
  }

  // 弹出框
  .mall-mask {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: #000;
    background: rgba(0, 0, 0, 0.6);
    z-index: 1001;
    .mall-popup {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 19rem;
      height: 20rem;  
      background: #FFFFFF;
      border-radius: 1rem;
      box-sizing: border-box;
      p {
        width: 100%;
        position: absolute;
        top: 5%;
        left: 50%;
        transform: translate(-50%, 0);        
        font-size: 1.33rem;
        font-family: PingFang SC;
        font-weight: 600;
        text-align: center;
        color: #F03227;
      }
      img {
        width: 6.57rem;
        height: 6.57rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
      .mall-btns {
        width: 100%;
        position: absolute;
        bottom: 1rem;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 1rem;
        .mall-btn {
          width: 8.13rem;
          height: 2.97rem;
          border-radius: 0.4rem;
          font-size: 1.33rem;
          font-family: PingFang SC;
          font-weight: 400;
          text-align: center;
          line-height: 2.97rem;
        }
        :nth-child(even) {
          color: #FFFFFF;
          background: #F03227;
        }
        :nth-child(odd) {
          color: #161617;
          border: 1px solid #D4D4D4;
        }
      }
    }
  }
}
</style>